var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mentee-feedback-title"},[_c('h1',[_vm._v("Fill in feedback")]),_c('div',[_vm._v("\n    Feedback submission DDL:"+_vm._s(_vm._f("addTwoDay")(_vm.time))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }